import ModalHeaderCloseCustom from "../../ModalHeaderCloseCustom/ModalHeaderCloseCustom";

export default function AuditNoteCloseButton(props) {
    return <ModalHeaderCloseCustom {...props} title={"Audit Note"} />;
}
